import type { JSX } from '@familyjs/core/components';
import { defineCustomElement } from '@familyjs/core/components/fml-modal.js';

import { createInlineOverlayComponent } from './createInlineOverlayComponent';

export const FmlModal = /*@__PURE__*/ createInlineOverlayComponent<JSX.FmlModal, HTMLFmlModalElement>(
  'fml-modal',
  defineCustomElement,
  true
);
